import { createSelector } from 'reselect';
import { mappedArrayToPageObject } from 'utils/mappedArrayToPageObject';

export const layersListSelector = (state) => state.layersList.layersList;
export const layersListLoadingSelector = (state) => state.layersList.loading;

export const mappedLayersObject = createSelector(layersListSelector, (list) =>
  mappedArrayToPageObject(list)
);
